import { CampaignsList } from "./components/CampaignsList";
import { Outlet } from "react-router";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { useGetCampaigns } from "./service/campaign-api";
import { SpinnerBlock } from "../../common/Spinner";

export const CampaignsPage = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: campaigns, isLoading } = useGetCampaigns(organizationKeyName);

  return (
    <>
      {isLoading || !campaigns ? (
        <SpinnerBlock />
      ) : (
        <CampaignsList campaigns={campaigns} />
      )}
      <Outlet />
    </>
  );
};
